import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mb-15" }
const _hoisted_2 = { class: "mb-4 d-flex align-center" }
const _hoisted_3 = {
  class: "mr-8 d-flex",
  style: {"flex-direction":"column","align-items":"flex-end"}
}
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "d-flex mb-4" }
const _hoisted_6 = {
  key: 1,
  class: "PatternMode"
}
const _hoisted_7 = { class: "panel-left" }
const _hoisted_8 = { class: "schedule-col name schedule-body-cell" }
const _hoisted_9 = { class: "schedule-header-cell" }
const _hoisted_10 = { class: "schedule-header-cell-calc" }
const _hoisted_11 = { class: "schedule-header-cell-calc" }
const _hoisted_12 = {
  key: 0,
  class: "panel-center"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "panel-center"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 2,
  class: "schedule-pattern-body-cell date"
}
const _hoisted_19 = { class: "panel-right" }
const _hoisted_20 = { class: "schedule-col actions schedule-body-cell" }
const _hoisted_21 = { class: "d-flex" }
const _hoisted_22 = {
  class: "d-flex justify-center align-center",
  style: {"width":"40px","text-align":"center"}
}
const _hoisted_23 = {
  class: "d-flex justify-center align-center",
  style: {"width":"40px"}
}
const _hoisted_24 = {
  class: "d-flex justify-center align-center",
  style: {"width":"40px"}
}
const _hoisted_25 = {
  class: "d-flex justify-center align-center",
  style: {"width":"80px","padding-left":"10px"}
}
const _hoisted_26 = { class: "pa-8" }
const _hoisted_27 = { class: "d-flex justify-space-between mb-4" }
const _hoisted_28 = { class: "staff-select__wrapper" }
const _hoisted_29 = { class: "my-4 staff d-flex align-center" }
const _hoisted_30 = { class: "mb-4" }
const _hoisted_31 = { class: "mb-4" }
const _hoisted_32 = { class: "mb-4" }
const _hoisted_33 = { class: "mb-4" }
const _hoisted_34 = { class: "mb-4" }
const _hoisted_35 = { class: "mb-4" }
const _hoisted_36 = { class: "d-flex align-center mb-4" }
const _hoisted_37 = { class: "d-flex" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { class: "d-flex justify-center mt-4" }
const _hoisted_41 = { class: "d-flex justify-center my-4" }
const _hoisted_42 = { class: "mb-4" }
const _hoisted_43 = { class: "mb-4" }
const _hoisted_44 = { class: "mb-4" }
const _hoisted_45 = { style: {"display":"flex","align-items":"center","justify-content":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_month_pager = _resolveComponent("month-pager")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_scrollable_panels = _resolveComponent("scrollable-panels")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_month_date_picker = _resolveComponent("month-date-picker")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_color_picker = _resolveComponent("color-picker")!
  const _component_hour_minute_input = _resolveComponent("hour-minute-input")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { class: "mb-4" }, {
      default: _withCtx(() => [
        _createVNode(_component_month_pager, {
          modelValue: _ctx.yearMonth,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.yearMonth) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    (_ctx.isFetchingPattern || _ctx.isFetching)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "primary",
          class: "my-4"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_btn, {
        variant: "flat",
        color: "primary",
        onClick: _cache[1] || (_cache[1] = () => (_ctx.isRegisterDialogOpen = true))
      }, {
        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
          _createTextVNode(" スタッフ登録 ", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_v_spacer),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, " 配慮が必要な園児に使用できる時間 : " + _toDisplayString(_ctx.subsidyChildcare ? _ctx.subsidyChildcare.maxHours.toFixed(1) : "-"), 1),
        _createElementVNode("div", null, " 残時間 : " + _toDisplayString(_ctx.subsidyChildcare ? _ctx.subsidyChildcare.remainingHours.toFixed(1) : "-"), 1)
      ]),
      _createVNode(_component_v_btn, {
        onClick: _ctx.downloadShiftPattern,
        color: "primary",
        variant: "outlined",
        disabled: _ctx.isFetching
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
              _createTextVNode("mdi-tray-arrow-down", -1)
            ]))]),
            _: 1
          }),
          _cache[21] || (_cache[21] = _createTextVNode(" ダウンロード ", -1))
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_v_checkbox, {
        modelValue: _ctx.isPatternMode,
        "onUpdate:modelValue": [
          _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isPatternMode) = $event)),
          _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePatternMode()))
        ],
        color: "primary",
        label: "連続入力モード"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        onClick: _ctx.openUpdatePlacement,
        color: "primary",
        variant: "outlined",
        disabled: _ctx.isFetching
      }, {
        default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
          _createTextVNode(" 配置計算の更新 ", -1)
        ]))]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    (_ctx.isPatternMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_v_btn, {
            variant: "outlined",
            disabled: _ctx.isFetching,
            style: {"border-radius":"20px","margin":"2px"},
            class: _normalizeClass({ 'non-active-delete-button': !this.isActiveDelete, 'active-delete-button': this.isActiveDelete }),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleActiveDelete()))
          }, {
            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
              _createTextVNode(" 削除 ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled", "class"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shiftPatternOptions, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.value
            }, [
              _createVNode(_component_v_btn, {
                variant: "outlined",
                disabled: _ctx.isFetching,
                style: {"border-radius":"20px","margin":"2px"},
                class: _normalizeClass({ 'non-active-button': !item.isActivePattern, 'active-button': item.isActivePattern }),
                onClick: ($event: any) => (_ctx.toggleActivePttern(item.value))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.text), 1)
                ]),
                _: 2
              }, 1032, ["disabled", "class", "onClick"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_scrollable_panels, null, {
        "left-panel-header": _withCtx(() => [...(_cache[24] || (_cache[24] = [
          _createElementVNode("div", { class: "panel-header panel-left" }, [
            _createElementVNode("div", { class: "schedule-col name" }, [
              _createElementVNode("div", { class: "schedule-header-cell" }, "氏名"),
              _createElementVNode("div", { class: "schedule-header-cell-calc" }, " 必要保育者数 (過不足) - 最大 "),
              _createElementVNode("div", { class: "schedule-header-cell-calc" }, " 必要保育者数 (過不足) - 最小 ")
            ])
          ], -1)
        ]))]),
        "left-panel-body": _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduleTableRows, (schedule, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "schedule-row",
                key: `row-${i}`
              }, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(schedule.name), 1)
              ]))
            }), 128))
          ])
        ]),
        "center-panel-header": _withCtx(() => [
          _createElementVNode("div", {
            class: "panel-header panel-center",
            style: _normalizeStyle(`width: ${_ctx.numberOfDates * 50}px; position: sticky; top: 0;`)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableDates, (date) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "schedule-col date",
                key: date.date,
                style: _normalizeStyle(`${date.date.indexOf('(土)') >= 0 ? 'color: blue;' : ''}${
                date.date.indexOf('(日)') >= 0 ? 'color: red;' : ''
              }`)
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", null, _toDisplayString(date.date), 1)
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(date.summaryMax), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(date.summaryMin), 1)
              ], 4))
            }), 128))
          ], 4)
        ]),
        "center-panel-body": _withCtx(() => [
          (!_ctx.isPatternMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduleTableRows, (schedule, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "schedule-row",
                    key: `row-${i}`,
                    style: _normalizeStyle(`width: ${_ctx.numberOfDates * 50}px;`)
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schedule.dailyPatterns, (dailyPattern) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(['schedule-col date']),
                        key: dailyPattern.date
                      }, [
                        (dailyPattern.abbreviation)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass([
                    'schedule-body-cell date',
                    dailyPattern.abbreviation ? 'active' : '',
                  ]),
                              style: _normalizeStyle(_ctx.getStyle(dailyPattern)),
                              onClick: ($event: any) => (_ctx.openDayDetail(schedule.user, dailyPattern.date))
                            }, _toDisplayString(dailyPattern.abbreviation), 15, _hoisted_13))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "schedule-body-cell date add",
                              onClick: ($event: any) => (
                    _ctx.openAddScheduleModal(schedule.user, dailyPattern.date)
                  )
                            }, [
                              _createVNode(_component_v_icon, {
                                size: "small",
                                color: "#d0d0d0"
                              }, {
                                default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                  _createTextVNode("mdi-plus", -1)
                                ]))]),
                                _: 1
                              })
                            ], 8, _hoisted_14))
                      ]))
                    }), 128))
                  ], 4))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.isPatternMode)
            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduleTableRows, (schedule, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "schedule-row",
                    key: `row-${i}`,
                    style: _normalizeStyle(`width: ${_ctx.numberOfDates * 50}px;`)
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schedule.dailyPatterns, (dailyPattern) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(['schedule-col date']),
                        key: dailyPattern.date
                      }, [
                        (dailyPattern.abbreviation)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass([
                    'schedule-pattern-body-cell date',
                    dailyPattern.abbreviation ? 'active' : '',
                  ]),
                              style: _normalizeStyle(_ctx.getStyle(dailyPattern)),
                              onClick: ($event: any) => (_ctx.PatternModeUpdate(schedule.user, dailyPattern.date))
                            }, _toDisplayString(dailyPattern.abbreviation), 15, _hoisted_16))
                          : _createCommentVNode("", true),
                        (!dailyPattern.abbreviation && !_ctx.isActiveDelete)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "schedule-pattern-body-cell date add",
                              onClick: ($event: any) => (_ctx.PatternModeAdd(schedule.user, dailyPattern.date))
                            }, [
                              _createVNode(_component_v_icon, {
                                size: "small",
                                color: "#d0d0d0"
                              }, {
                                default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                  _createTextVNode("mdi-plus", -1)
                                ]))]),
                                _: 1
                              })
                            ], 8, _hoisted_17))
                          : _createCommentVNode("", true),
                        (!dailyPattern.abbreviation && _ctx.isActiveDelete)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createVNode(_component_v_icon, {
                                size: "small",
                                color: "#d0d0d0"
                              }, {
                                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                  _createTextVNode("mdi-plus", -1)
                                ]))]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ], 4))
                }), 128))
              ], 512)), [
                [_vShow, !_ctx.isPatternLoading]
              ])
            : _createCommentVNode("", true)
        ]),
        "right-panel-header": _withCtx(() => [...(_cache[28] || (_cache[28] = [
          _createElementVNode("div", { class: "panel-header panel-right" }, [
            _createElementVNode("div", { class: "schedule-col actions" }, [
              _createElementVNode("div", { class: "schedule-header-cell" }),
              _createElementVNode("div", {
                class: "schedule-header-cell",
                style: {"padding":"0"}
              }, [
                _createElementVNode("div", { class: "d-flex" }, [
                  _createElementVNode("div", {
                    class: "d-flex justify-center align-center",
                    style: {"width":"40px"}
                  }, " 日数 "),
                  _createElementVNode("div", {
                    class: "d-flex justify-center align-center",
                    style: {"width":"40px"}
                  }, [
                    _createTextVNode(" 合計"),
                    _createElementVNode("br"),
                    _createTextVNode("時間 ")
                  ]),
                  _createElementVNode("div", {
                    class: "d-flex justify-center align-center",
                    style: {"width":"40px"}
                  }, " 有休 ")
                ])
              ])
            ])
          ], -1)
        ]))]),
        "right-panel-body": _withCtx(() => [
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduleTableRows, (schedule, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "schedule-row",
                key: `row-${i}`
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(schedule.totalShiftWorkingDays), 1),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(schedule.totalShiftHours), 1),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(schedule.totalShiftPaidHolidays), 1),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_v_btn, {
                        variant: "outlined",
                        size: "small",
                        color: "primary",
                        onClick: ($event: any) => (_ctx.openPatternModal(schedule.user))
                      }, {
                        default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                          _createTextVNode(" 一括登録 ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_dialog, {
      "max-width": "640px",
      modelValue: _ctx.isRegisterDialogOpen,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isRegisterDialogOpen) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, [
              (_ctx.isCopyingMembersFromLastMonth)
                ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                    key: 0,
                    indeterminate: "",
                    color: "primary",
                    class: "my-4"
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_v_checkbox, {
                  label: "スタッフ全員にチェック",
                  "hide-details": "auto",
                  density: "compact",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectAllStaffs(Boolean($event)))),
                  color: "primary"
                })
              ]),
              _createVNode(_component_v_divider),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_draggable, {
                  modelValue: _ctx.staffObjects,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.staffObjects) = $event)),
                  "item-key": "userId",
                  handle: ".drag-handle"
                }, {
                  item: _withCtx(({ element: staff }) => [
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_v_icon, {
                        class: "mr-2 drag-handle",
                        size: "small"
                      }, {
                        default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                          _createTextVNode(" mdi-drag ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_v_checkbox, {
                        label: `${staff.lastName} ${staff.firstName}`,
                        "model-value": staff.isRegistered,
                        "hide-details": "",
                        density: "compact",
                        "onUpdate:modelValue": ($event: any) => (_ctx.addRegisterUserId(Boolean($event), staff.userId)),
                        color: "primary"
                      }, null, 8, ["label", "model-value", "onUpdate:modelValue"])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createVNode(_component_v_card_actions, { class: "justify-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  color: "primary",
                  class: "mx-2",
                  onClick: _ctx.updateStaffIds
                }, {
                  default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                    _createTextVNode(" 保存 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            (_ctx.isUpdatingStaffs)
              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                  key: 0,
                  indeterminate: "",
                  color: "primary"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      "max-width": "1080px",
      modelValue: _ctx.isPatternModalOpen,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isPatternModalOpen) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.applyingUser)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                    _createTextVNode("月間スタッフ予定登録", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_30, [
                              _cache[33] || (_cache[33] = _createElementVNode("h4", null, "スタッフ名", -1)),
                              _createElementVNode("h3", null, _toDisplayString(_ctx.applyingUser.lastName) + " " + _toDisplayString(_ctx.applyingUser.firstName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              _cache[34] || (_cache[34] = _createElementVNode("h4", null, "シフトパターン", -1)),
                              _createVNode(_component_v_select, {
                                variant: "outlined",
                                items: _ctx.shiftPatternOptions,
                                "item-title": "text",
                                "item-value": "value",
                                modelValue: _ctx.applyingPatternId,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.applyingPatternId) = $event))
                              }, null, 8, ["items", "modelValue"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_month_date_picker, {
                              yearMonth: _ctx.yearMonth,
                              modelValue: _ctx.applyingDates,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.applyingDates) = $event))
                            }, {
                              date: _withCtx(({ date }) => [
                                _createElementVNode("div", {
                                  class: _normalizeClass(['month-date-picker-cell']),
                                  style: _normalizeStyle(`background-color: ${
                      _ctx.getRegisteredSchedule(date)
                        ? _ctx.getRegisteredSchedule(date)?.color
                        : null
                    }`)
                                }, [
                                  (_ctx.getRegisteredSchedule(date))
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        style: _normalizeStyle(`color: ${_ctx.getRegisteredSchedule(date)?.textcolor}`)
                                      }, _toDisplayString(_ctx.getRegisteredSchedule(date)?.abbreviation), 5))
                                    : _createCommentVNode("", true)
                                ], 4)
                              ]),
                              _: 1
                            }, 8, ["yearMonth", "modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      color: "primary",
                      class: "mx-2",
                      disabled: !_ctx.isApplyButtonValid,
                      onClick: _ctx.applyPattern
                    }, {
                      default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                        _createTextVNode(" 保存 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ]),
                  _: 1
                }),
                (_ctx.isApplying)
                  ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                      key: 0,
                      indeterminate: "",
                      color: "primary"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      "max-width": "1080px",
      modelValue: _ctx.isEditModalOpen,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isEditModalOpen) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                _createTextVNode("シフトパターン編集", -1)
              ]))]),
              _: 1
            }),
            (_ctx.editingPattern && _ctx.editingUser)
              ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "mb-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_32, [
                              _cache[37] || (_cache[37] = _createElementVNode("h4", null, "スタッフ名", -1)),
                              _createElementVNode("h3", null, _toDisplayString(_ctx.editingUser.lastName) + " " + _toDisplayString(_ctx.editingUser.firstName), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_33, [
                              _cache[38] || (_cache[38] = _createElementVNode("h4", null, "日付", -1)),
                              _createElementVNode("h3", null, _toDisplayString(_ctx.editingDate), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_text_field, {
                      class: "mb-4",
                      "hide-details": "",
                      variant: "outlined",
                      label: "名称 *",
                      modelValue: _ctx.editingPattern.name,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editingPattern.name) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                      class: "mb-4",
                      "hide-details": "",
                      variant: "outlined",
                      label: "略称 *",
                      modelValue: _ctx.editingPattern.abbreviation,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editingPattern.abbreviation) = $event))
                    }, null, 8, ["modelValue"]),
                    _cache[47] || (_cache[47] = _createElementVNode("div", null, "カラー", -1)),
                    _createElementVNode("div", _hoisted_34, [
                      _createVNode(_component_color_picker, {
                        modelValue: _ctx.editingPattern.color as string,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editingPattern.color as string) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _cache[48] || (_cache[48] = _createElementVNode("div", { class: "menu-header" }, "時間枠", -1)),
                    _createElementVNode("div", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editingPattern.timetables, (timetable, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, [
                          (timetable.operationType !== 'remove')
                            ? (_openBlock(), _createBlock(_component_v_card, {
                                key: 0,
                                variant: "outlined",
                                class: "pa-4 my-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    class: "mb-4",
                                    variant: "outlined",
                                    label: "名称 *",
                                    modelValue: timetable.name,
                                    "onUpdate:modelValue": ($event: any) => ((timetable.name) = $event),
                                    rules: [_ctx.required]
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"]),
                                  _createVNode(_component_v_text_field, {
                                    class: "mb-4",
                                    variant: "outlined",
                                    label: "略称 *",
                                    modelValue: timetable.abbreviation,
                                    "onUpdate:modelValue": ($event: any) => ((timetable.abbreviation) = $event),
                                    rules: [_ctx.required, _ctx.isAbbreviationValid]
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"]),
                                  _cache[43] || (_cache[43] = _createElementVNode("div", null, "カラー", -1)),
                                  _createElementVNode("div", _hoisted_35, [
                                    _createVNode(_component_color_picker, {
                                      modelValue: timetable.color as string,
                                      "onUpdate:modelValue": ($event: any) => ((timetable.color as string) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _cache[44] || (_cache[44] = _createElementVNode("h4", { class: "mb-2" }, "時間", -1)),
                                  _createElementVNode("div", _hoisted_36, [
                                    _createVNode(_component_hour_minute_input, {
                                      modelValue: timetable.startMin,
                                      "onUpdate:modelValue": ($event: any) => ((timetable.startMin) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _cache[39] || (_cache[39] = _createElementVNode("div", { class: "px-4" }, "〜", -1)),
                                    _createElementVNode("div", _hoisted_37, [
                                      _createVNode(_component_hour_minute_input, {
                                        modelValue: timetable.endMin,
                                        "onUpdate:modelValue": ($event: any) => ((timetable.endMin) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ])
                                  ]),
                                  _cache[45] || (_cache[45] = _createElementVNode("h4", { class: "mb-2" }, "項目", -1)),
                                  _createVNode(_component_v_select, {
                                    class: "mb-4",
                                    items: _ctx.descriptions,
                                    "item-title": "text",
                                    "item-value": "value",
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "",
                                    modelValue: timetable.category,
                                    "onUpdate:modelValue": ($event: any) => ((timetable.category) = $event),
                                    color: "primary"
                                  }, null, 8, ["items", "modelValue", "onUpdate:modelValue"]),
                                  (timetable.category === 'holiday')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                        _cache[40] || (_cache[40] = _createElementVNode("h4", { class: "mb-2" }, "お休みの理由", -1)),
                                        _createVNode(_component_v_text_field, {
                                          class: "mb-4",
                                          "hide-details": "",
                                          density: "compact",
                                          variant: "outlined",
                                          modelValue: timetable.comment,
                                          "onUpdate:modelValue": ($event: any) => ((timetable.comment) = $event),
                                          color: "primary"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (timetable.category === 'workDescription')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                        _cache[41] || (_cache[41] = _createElementVNode("h4", { class: "mb-2" }, "作業内容", -1)),
                                        _createVNode(_component_v_select, {
                                          class: "mb-4",
                                          items: _ctx.workDescriptionOptions,
                                          "item-title": "text",
                                          "item-value": "value",
                                          variant: "outlined",
                                          density: "compact",
                                          "hide-details": "",
                                          modelValue: timetable.workDescriptionId,
                                          "onUpdate:modelValue": ($event: any) => ((timetable.workDescriptionId) = $event),
                                          color: "primary"
                                        }, null, 8, ["items", "modelValue", "onUpdate:modelValue"])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_40, [
                                    _createVNode(_component_v_btn, {
                                      variant: "flat",
                                      color: "red",
                                      theme: "dark",
                                      onClick: ($event: any) => (
                      _ctx.removeTimetableFromEditingPattern(
                        i,
                        timetable.timetableId
                      )
                    )
                                    }, {
                                      default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                        _createTextVNode(" 時間枠を削除 ", -1)
                                      ]))]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_v_btn, {
                        variant: "flat",
                        color: "primary",
                        onClick: _ctx.addTimetableToEditingPattern
                      }, {
                        default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                          _createTextVNode(" 時間枠を追加 ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_card_actions, { class: "justify-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  color: "red",
                  theme: "dark",
                  class: "mx-2",
                  loading: _ctx.isUpdatingShift,
                  onClick: _ctx.deleteEditingPattern
                }, {
                  default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                    _createTextVNode(" 削除 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "onClick"]),
                _createVNode(_component_v_btn, {
                  variant: "flat",
                  color: "primary",
                  class: "mx-2",
                  loading: _ctx.isUpdatingShift,
                  onClick: _ctx.saveEditingPattern
                }, {
                  default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                    _createTextVNode(" 保存 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ]),
              _: 1
            }),
            (_ctx.isUpdatingShift)
              ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                  key: 1,
                  indeterminate: "",
                  color: "primary"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      "max-width": "1080px",
      modelValue: _ctx.isAddScheduleModalOpen,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.isAddScheduleModalOpen) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.addingUser && _ctx.addingDate && !_ctx.isPatternMode)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                    _createTextVNode("シフトパターン追加", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "mb-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_42, [
                              _cache[52] || (_cache[52] = _createElementVNode("h4", null, "スタッフ名", -1)),
                              _createElementVNode("h3", null, _toDisplayString(_ctx.addingUser.lastName) + " " + _toDisplayString(_ctx.addingUser.firstName), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_43, [
                              _cache[53] || (_cache[53] = _createElementVNode("h4", null, "日付", -1)),
                              _createElementVNode("h3", null, _toDisplayString(_ctx.addingDate), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_44, [
                      _cache[54] || (_cache[54] = _createElementVNode("h4", null, "シフトパターン", -1)),
                      _createVNode(_component_v_select, {
                        variant: "outlined",
                        items: _ctx.shiftPatternOptions,
                        "item-title": "text",
                        "item-value": "value",
                        modelValue: _ctx.addingPatternId,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.addingPatternId) = $event))
                      }, null, 8, ["items", "modelValue"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      color: "primary",
                      class: "mx-2",
                      disabled: !_ctx.addingPatternId,
                      onClick: _ctx.addPatternWithUserAndDate
                    }, {
                      default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                        _createTextVNode(" 保存 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ]),
                  _: 1
                }),
                (_ctx.isApplying)
                  ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                      key: 0,
                      indeterminate: "",
                      color: "primary"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      "max-width": "600px",
      modelValue: _ctx.isUpdatePlacement,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.isUpdatePlacement) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { style: {"align-items":"center","justify-content":"center","height":"180px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { style: {"display":"flex","align-items":"center","justify-content":"center"} }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { style: {"color":"red"} }, {
                  default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                    _createTextVNode("mdi-information-outline", -1)
                  ]))]),
                  _: 1
                }),
                _cache[57] || (_cache[57] = _createTextVNode("  配置計算を実行しますか？ ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { style: {"display":"flex","align-items":"center","justify-content":"center","color":"black"} }, {
              default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                _createTextVNode("配置計算には2分ほど処理時間がかかります", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    variant: "flat",
                    color: "primary",
                    class: "mx-2",
                    onClick: _ctx.UpdateExpectedPlacement
                  }, {
                    default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                      _createTextVNode(" 実行 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_overlay, {
      modelValue: _ctx.isPatternLoading,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.isPatternLoading) = $event)),
      class: "align-center justify-center",
      persistent: "",
      "z-index": "5000"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          height: "200",
          width: "200",
          class: "d-flex align-center justify-center",
          rounded: "lg",
          elevation: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              color: "primary",
              indeterminate: "",
              size: 150
            }, {
              default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                _createTextVNode(" 処理中... ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}